import React from 'react'

function ErrorDevice() {
    return (
        <div className="container">
            <div className="row">
                <div className="d-flex align-items-center text-center align-self-center">
                    <div className="col-12 mt-5" style={{height: '100vh'}}>
                        <p className="text-secondary">Mohon maaf, aplikasi nya hanya bisa dilihat di desktop saja</p>
                        <h1 className="mt-3">
                            :'(
                        </h1>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ErrorDevice
